import React from "react";
import { LinkedinLogo, Medal } from "@phosphor-icons/react";

const TEAM = [
  {
    name: "Ольга Андрианова",
    role: "CEO & Co-founder",
    img: "/external-assets/2a60hkph_7c5f8b9d121ef0e52a72af14ea6e8529f62d897c.jpg",
    objectPosition: "center 28%",
    bullets: [
      "17 лет в Intel — лидерство в Enterprise-направлении",
      "Экс-директор ИИ-проектов Сбера",
      "Эксперт по B2B-продажам в Европе и РФ",
    ],
    tag: "ex-Intel · ex-Sber",
    testid: "team-olga",
  },
  {
    name: "Дмитрий Сивков",
    role: "CTO & Co-founder",
    img: "/external-assets/qabuq8ow_efafe194fed7b4fccd176cc28ac84ced4ee8cb09.png",
    objectPosition: "center 30%",
    bullets: [
      "20 лет в Intel — архитектура систем оптимизации HW/SW",
      "Кандидат физико-математических наук",
      "Автор 3 международных патентов",
    ],
    tag: "ex-Intel · к.ф.-м.н.",
    testid: "team-dmitry",
  },
  {
    name: "Андрей",
    role: "CPO",
    img: "/external-assets/ogimv2yh_Andy.png",
    objectPosition: "center 25%",
    bullets: [
      "10+ лет в международном BigTech и стартапах",
      "Запуск продуктов на рынки EMEA и APAC",
      "Product strategy для Deep Tech и Enterprise",
    ],
    tag: "BigTech · ex-Startups",
    testid: "team-andrey",
  },
  {
    name: "Максим Маслов",
    role: "Advisor · Бизнес-ангел",
    img: "/external-assets/pm26xerx_5267010926320229361.jpg",
    objectPosition: "center 22%",
    bullets: [
      "Co-founder & CTO — Eltechs (deep-tech startup)",
      "Huawei (3 года) — Архитектор",
      "Baikal Electronics, группа «Астра» — GPU Architect",
    ],
    tag: "ex-Eltechs · Baikal",
    testid: "team-maxim",
  },
  {
    name: "Антон Шоколов",
    role: "AI Research & Engineering",
    img: "/external-assets/vgjpnlz7_5bui0c9s_Anton.png",
    objectPosition: "center 20%",
    bullets: [
      "Новосибирский государственный университет",
      "Исследования в ИИ и разработке ПО",
    ],
    tag: "NSU · AI Research",
    testid: "team-anton",
  },
];

export const Team = () => {
  return (
    <section id="team" data-testid="team-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-14">
          <div className="mono text-xs uppercase tracking-[0.22em] text-brand-cyan mb-3">
            / 07 — Команда
          </div>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight max-w-3xl">
            Архитекторы железа.
            <br />
            <span className="text-muted">Один продукт.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {TEAM.map((m) => (
            <div
              key={m.testid}
              data-testid={m.testid}
              className="group glass rounded-2xl overflow-hidden hover:-translate-y-1 transition-transform duration-300 flex flex-col"
            >
              <div className="relative w-full h-72 overflow-hidden flex-shrink-0">
                <img
                  src={m.img}
                  alt={m.name}
                  style={{ objectPosition: m.objectPosition }}
                  className="absolute inset-0 w-full h-full object-cover grayscale-[30%] saturate-[0.9] group-hover:grayscale-0 group-hover:saturate-100 transition-all duration-500"
                  loading="lazy"
                  data-testid={`${m.testid}-photo`}
                />
                <div
                  className="absolute inset-0 mix-blend-overlay"
                  style={{
                    background:
                      "linear-gradient(135deg, rgba(0,80,230,0.25) 0%, rgba(0,0,0,0) 40%, rgba(0,153,201,0.18) 100%)",
                  }}
                />
                <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-white/95 via-white/40 to-transparent" />
                <div className="absolute top-3 left-3 flex items-center gap-1.5 px-2 py-1 rounded-full bg-white/85 border border-ink-text/10 backdrop-blur-sm mono text-[9px] uppercase tracking-widest text-brand">
                  <span className="w-1 h-1 rounded-full bg-brand-cyan shadow-[0_0_6px_#0099C9]" />
                  {m.tag.split(" · ")[0]}
                </div>
              </div>

              <div className="flex-1 p-7">
                <div className="font-heading text-2xl font-bold tracking-tight">{m.name}</div>
                <div className="mt-1 mono text-xs uppercase tracking-widest text-brand-cyan">
                  {m.role}
                </div>
                <ul className="mt-5 space-y-2.5">
                  {m.bullets.map((b, i) => (
                    <li key={i} className="flex items-start gap-2.5 text-sm text-muted">
                      <Medal size={14} weight="duotone" className="text-brand-cyan mt-0.5 flex-shrink-0" />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
                <div className="mt-6 inline-flex items-center gap-2 text-xs text-muted">
                  <LinkedinLogo size={14} weight="fill" />
                  <span className="mono uppercase tracking-widest">{m.tag}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
